<!--
 * @Description: 
 * @Version: 1.0.0
 * @Date: 2022-04-11 10:16:14
 * @LastEditors: yawen Yang
 * @LastEditTime: 2024-03-06 17:48:19
-->
<template>
  <div class="captcha"></div>
</template>

<script>
export default {
  name: "AliCaptcha",
  props: ["captchaConfig"],
  mounted() {
    this.init();
  },
  methods: {
    init(){
      if (typeof window.initAlicom4 === "function") {
        window.initAlicom4(
          this.captchaConfig.config,
          this.captchaConfig.handler
        );
      } else {
        // 脚本尚未加载完成，轮询等待
        setTimeout(() => this.init(), 100);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aliCaptcha.vue